/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../__root"
import { Route as AuthenticatedRouteImport } from "./../_authenticated"
import { Route as AuthenticatedIndexRouteImport } from "./../_authenticated/index"
import { Route as AuthenticatedProfileRouteImport } from "./../_authenticated/profile"
import { Route as AuthenticatedApi_keysIndexRouteImport } from "./../_authenticated/api_keys/index"
import { Route as AuthenticatedApi_keysCreateRouteImport } from "./../_authenticated/api_keys/create"
import { Route as AuthenticatedBillingIndexRouteImport } from "./../_authenticated/billing/index"
import { Route as AuthenticatedBillingEditRouteImport } from "./../_authenticated/billing/edit"
import { Route as AuthenticatedMembersIndexRouteImport } from "./../_authenticated/members/index"
import { Route as AuthenticatedApi_keysApiKeyIdIndexRouteImport } from "./../_authenticated/api_keys/$apiKeyId/index"
import { Route as AuthenticatedApi_keysApiKeyIdEditRouteImport } from "./../_authenticated/api_keys/$apiKeyId/edit"
import { Route as AuthenticatedApi_keysRolesRoleIdRouteImport } from "./../_authenticated/api_keys/roles/$roleId"
import { Route as AuthenticatedMembersMemberIdIndexRouteImport } from "./../_authenticated/members/$memberId/index"
import { Route as AuthenticatedMembersMemberIdConfirmRouteImport } from "./../_authenticated/members/$memberId/confirm"
import { Route as AuthenticatedMembersMemberIdEditRouteImport } from "./../_authenticated/members/$memberId/edit"
import { Route as AuthenticatedMembersCreateIndexRouteImport } from "./../_authenticated/members/create/index"
import { Route as AuthenticatedMembersCreateConfirmRouteImport } from "./../_authenticated/members/create/confirm"
import { Route as AuthenticatedUser_rolesPlanIdIndexRouteImport } from "./../_authenticated/user_roles/$planId/index"

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApi_keysIndexRoute =
  AuthenticatedApi_keysIndexRouteImport.update({
    id: "/api_keys/",
    path: "/api_keys/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApi_keysCreateRoute =
  AuthenticatedApi_keysCreateRouteImport.update({
    id: "/api_keys/create",
    path: "/api_keys/create",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingIndexRoute =
  AuthenticatedBillingIndexRouteImport.update({
    id: "/billing/",
    path: "/billing/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingEditRoute =
  AuthenticatedBillingEditRouteImport.update({
    id: "/billing/edit",
    path: "/billing/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembersIndexRoute =
  AuthenticatedMembersIndexRouteImport.update({
    id: "/members/",
    path: "/members/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApi_keysApiKeyIdIndexRoute =
  AuthenticatedApi_keysApiKeyIdIndexRouteImport.update({
    id: "/api_keys/$apiKeyId/",
    path: "/api_keys/$apiKeyId/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApi_keysApiKeyIdEditRoute =
  AuthenticatedApi_keysApiKeyIdEditRouteImport.update({
    id: "/api_keys/$apiKeyId/edit",
    path: "/api_keys/$apiKeyId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApi_keysRolesRoleIdRoute =
  AuthenticatedApi_keysRolesRoleIdRouteImport.update({
    id: "/api_keys/roles/$roleId",
    path: "/api_keys/roles/$roleId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembersMemberIdIndexRoute =
  AuthenticatedMembersMemberIdIndexRouteImport.update({
    id: "/members/$memberId/",
    path: "/members/$memberId/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembersMemberIdConfirmRoute =
  AuthenticatedMembersMemberIdConfirmRouteImport.update({
    id: "/members/$memberId/confirm",
    path: "/members/$memberId/confirm",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembersMemberIdEditRoute =
  AuthenticatedMembersMemberIdEditRouteImport.update({
    id: "/members/$memberId/edit",
    path: "/members/$memberId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembersCreateIndexRoute =
  AuthenticatedMembersCreateIndexRouteImport.update({
    id: "/members/create/",
    path: "/members/create/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembersCreateConfirmRoute =
  AuthenticatedMembersCreateConfirmRouteImport.update({
    id: "/members/create/confirm",
    path: "/members/create/confirm",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUser_rolesPlanIdIndexRoute =
  AuthenticatedUser_rolesPlanIdIndexRouteImport.update({
    id: "/user_roles/$planId/",
    path: "/user_roles/$planId/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/profile": typeof AuthenticatedProfileRoute
  "/api_keys/create": typeof AuthenticatedApi_keysCreateRoute
  "/billing/edit": typeof AuthenticatedBillingEditRoute
  "/api_keys/": typeof AuthenticatedApi_keysIndexRoute
  "/billing/": typeof AuthenticatedBillingIndexRoute
  "/members/": typeof AuthenticatedMembersIndexRoute
  "/api_keys/$apiKeyId/edit": typeof AuthenticatedApi_keysApiKeyIdEditRoute
  "/api_keys/roles/$roleId": typeof AuthenticatedApi_keysRolesRoleIdRoute
  "/members/$memberId/confirm": typeof AuthenticatedMembersMemberIdConfirmRoute
  "/members/$memberId/edit": typeof AuthenticatedMembersMemberIdEditRoute
  "/members/create/confirm": typeof AuthenticatedMembersCreateConfirmRoute
  "/api_keys/$apiKeyId/": typeof AuthenticatedApi_keysApiKeyIdIndexRoute
  "/members/$memberId/": typeof AuthenticatedMembersMemberIdIndexRoute
  "/members/create/": typeof AuthenticatedMembersCreateIndexRoute
  "/user_roles/$planId/": typeof AuthenticatedUser_rolesPlanIdIndexRoute
}
export interface FileRoutesByTo {
  "/profile": typeof AuthenticatedProfileRoute
  "/": typeof AuthenticatedIndexRoute
  "/api_keys/create": typeof AuthenticatedApi_keysCreateRoute
  "/billing/edit": typeof AuthenticatedBillingEditRoute
  "/api_keys": typeof AuthenticatedApi_keysIndexRoute
  "/billing": typeof AuthenticatedBillingIndexRoute
  "/members": typeof AuthenticatedMembersIndexRoute
  "/api_keys/$apiKeyId/edit": typeof AuthenticatedApi_keysApiKeyIdEditRoute
  "/api_keys/roles/$roleId": typeof AuthenticatedApi_keysRolesRoleIdRoute
  "/members/$memberId/confirm": typeof AuthenticatedMembersMemberIdConfirmRoute
  "/members/$memberId/edit": typeof AuthenticatedMembersMemberIdEditRoute
  "/members/create/confirm": typeof AuthenticatedMembersCreateConfirmRoute
  "/api_keys/$apiKeyId": typeof AuthenticatedApi_keysApiKeyIdIndexRoute
  "/members/$memberId": typeof AuthenticatedMembersMemberIdIndexRoute
  "/members/create": typeof AuthenticatedMembersCreateIndexRoute
  "/user_roles/$planId": typeof AuthenticatedUser_rolesPlanIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/_authenticated/profile": typeof AuthenticatedProfileRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
  "/_authenticated/api_keys/create": typeof AuthenticatedApi_keysCreateRoute
  "/_authenticated/billing/edit": typeof AuthenticatedBillingEditRoute
  "/_authenticated/api_keys/": typeof AuthenticatedApi_keysIndexRoute
  "/_authenticated/billing/": typeof AuthenticatedBillingIndexRoute
  "/_authenticated/members/": typeof AuthenticatedMembersIndexRoute
  "/_authenticated/api_keys/$apiKeyId/edit": typeof AuthenticatedApi_keysApiKeyIdEditRoute
  "/_authenticated/api_keys/roles/$roleId": typeof AuthenticatedApi_keysRolesRoleIdRoute
  "/_authenticated/members/$memberId/confirm": typeof AuthenticatedMembersMemberIdConfirmRoute
  "/_authenticated/members/$memberId/edit": typeof AuthenticatedMembersMemberIdEditRoute
  "/_authenticated/members/create/confirm": typeof AuthenticatedMembersCreateConfirmRoute
  "/_authenticated/api_keys/$apiKeyId/": typeof AuthenticatedApi_keysApiKeyIdIndexRoute
  "/_authenticated/members/$memberId/": typeof AuthenticatedMembersMemberIdIndexRoute
  "/_authenticated/members/create/": typeof AuthenticatedMembersCreateIndexRoute
  "/_authenticated/user_roles/$planId/": typeof AuthenticatedUser_rolesPlanIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/profile"
    | "/api_keys/create"
    | "/billing/edit"
    | "/api_keys/"
    | "/billing/"
    | "/members/"
    | "/api_keys/$apiKeyId/edit"
    | "/api_keys/roles/$roleId"
    | "/members/$memberId/confirm"
    | "/members/$memberId/edit"
    | "/members/create/confirm"
    | "/api_keys/$apiKeyId/"
    | "/members/$memberId/"
    | "/members/create/"
    | "/user_roles/$planId/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/profile"
    | "/"
    | "/api_keys/create"
    | "/billing/edit"
    | "/api_keys"
    | "/billing"
    | "/members"
    | "/api_keys/$apiKeyId/edit"
    | "/api_keys/roles/$roleId"
    | "/members/$memberId/confirm"
    | "/members/$memberId/edit"
    | "/members/create/confirm"
    | "/api_keys/$apiKeyId"
    | "/members/$memberId"
    | "/members/create"
    | "/user_roles/$planId"
  id:
    | "__root__"
    | "/_authenticated"
    | "/_authenticated/profile"
    | "/_authenticated/"
    | "/_authenticated/api_keys/create"
    | "/_authenticated/billing/edit"
    | "/_authenticated/api_keys/"
    | "/_authenticated/billing/"
    | "/_authenticated/members/"
    | "/_authenticated/api_keys/$apiKeyId/edit"
    | "/_authenticated/api_keys/roles/$roleId"
    | "/_authenticated/members/$memberId/confirm"
    | "/_authenticated/members/$memberId/edit"
    | "/_authenticated/members/create/confirm"
    | "/_authenticated/api_keys/$apiKeyId/"
    | "/_authenticated/members/$memberId/"
    | "/_authenticated/members/create/"
    | "/_authenticated/user_roles/$planId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/profile": {
      id: "/_authenticated/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/api_keys/": {
      id: "/_authenticated/api_keys/"
      path: "/api_keys"
      fullPath: "/api_keys/"
      preLoaderRoute: typeof AuthenticatedApi_keysIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/api_keys/create": {
      id: "/_authenticated/api_keys/create"
      path: "/api_keys/create"
      fullPath: "/api_keys/create"
      preLoaderRoute: typeof AuthenticatedApi_keysCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/billing/": {
      id: "/_authenticated/billing/"
      path: "/billing"
      fullPath: "/billing/"
      preLoaderRoute: typeof AuthenticatedBillingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/billing/edit": {
      id: "/_authenticated/billing/edit"
      path: "/billing/edit"
      fullPath: "/billing/edit"
      preLoaderRoute: typeof AuthenticatedBillingEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/members/": {
      id: "/_authenticated/members/"
      path: "/members"
      fullPath: "/members/"
      preLoaderRoute: typeof AuthenticatedMembersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/api_keys/$apiKeyId/": {
      id: "/_authenticated/api_keys/$apiKeyId/"
      path: "/api_keys/$apiKeyId"
      fullPath: "/api_keys/$apiKeyId/"
      preLoaderRoute: typeof AuthenticatedApi_keysApiKeyIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/api_keys/$apiKeyId/edit": {
      id: "/_authenticated/api_keys/$apiKeyId/edit"
      path: "/api_keys/$apiKeyId/edit"
      fullPath: "/api_keys/$apiKeyId/edit"
      preLoaderRoute: typeof AuthenticatedApi_keysApiKeyIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/api_keys/roles/$roleId": {
      id: "/_authenticated/api_keys/roles/$roleId"
      path: "/api_keys/roles/$roleId"
      fullPath: "/api_keys/roles/$roleId"
      preLoaderRoute: typeof AuthenticatedApi_keysRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/members/$memberId/": {
      id: "/_authenticated/members/$memberId/"
      path: "/members/$memberId"
      fullPath: "/members/$memberId/"
      preLoaderRoute: typeof AuthenticatedMembersMemberIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/members/$memberId/confirm": {
      id: "/_authenticated/members/$memberId/confirm"
      path: "/members/$memberId/confirm"
      fullPath: "/members/$memberId/confirm"
      preLoaderRoute: typeof AuthenticatedMembersMemberIdConfirmRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/members/$memberId/edit": {
      id: "/_authenticated/members/$memberId/edit"
      path: "/members/$memberId/edit"
      fullPath: "/members/$memberId/edit"
      preLoaderRoute: typeof AuthenticatedMembersMemberIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/members/create/": {
      id: "/_authenticated/members/create/"
      path: "/members/create"
      fullPath: "/members/create/"
      preLoaderRoute: typeof AuthenticatedMembersCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/members/create/confirm": {
      id: "/_authenticated/members/create/confirm"
      path: "/members/create/confirm"
      fullPath: "/members/create/confirm"
      preLoaderRoute: typeof AuthenticatedMembersCreateConfirmRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/user_roles/$planId/": {
      id: "/_authenticated/user_roles/$planId/"
      path: "/user_roles/$planId"
      fullPath: "/user_roles/$planId/"
      preLoaderRoute: typeof AuthenticatedUser_rolesPlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedApi_keysCreateRoute: typeof AuthenticatedApi_keysCreateRoute
  AuthenticatedBillingEditRoute: typeof AuthenticatedBillingEditRoute
  AuthenticatedApi_keysIndexRoute: typeof AuthenticatedApi_keysIndexRoute
  AuthenticatedBillingIndexRoute: typeof AuthenticatedBillingIndexRoute
  AuthenticatedMembersIndexRoute: typeof AuthenticatedMembersIndexRoute
  AuthenticatedApi_keysApiKeyIdEditRoute: typeof AuthenticatedApi_keysApiKeyIdEditRoute
  AuthenticatedApi_keysRolesRoleIdRoute: typeof AuthenticatedApi_keysRolesRoleIdRoute
  AuthenticatedMembersMemberIdConfirmRoute: typeof AuthenticatedMembersMemberIdConfirmRoute
  AuthenticatedMembersMemberIdEditRoute: typeof AuthenticatedMembersMemberIdEditRoute
  AuthenticatedMembersCreateConfirmRoute: typeof AuthenticatedMembersCreateConfirmRoute
  AuthenticatedApi_keysApiKeyIdIndexRoute: typeof AuthenticatedApi_keysApiKeyIdIndexRoute
  AuthenticatedMembersMemberIdIndexRoute: typeof AuthenticatedMembersMemberIdIndexRoute
  AuthenticatedMembersCreateIndexRoute: typeof AuthenticatedMembersCreateIndexRoute
  AuthenticatedUser_rolesPlanIdIndexRoute: typeof AuthenticatedUser_rolesPlanIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedApi_keysCreateRoute: AuthenticatedApi_keysCreateRoute,
  AuthenticatedBillingEditRoute: AuthenticatedBillingEditRoute,
  AuthenticatedApi_keysIndexRoute: AuthenticatedApi_keysIndexRoute,
  AuthenticatedBillingIndexRoute: AuthenticatedBillingIndexRoute,
  AuthenticatedMembersIndexRoute: AuthenticatedMembersIndexRoute,
  AuthenticatedApi_keysApiKeyIdEditRoute:
    AuthenticatedApi_keysApiKeyIdEditRoute,
  AuthenticatedApi_keysRolesRoleIdRoute: AuthenticatedApi_keysRolesRoleIdRoute,
  AuthenticatedMembersMemberIdConfirmRoute:
    AuthenticatedMembersMemberIdConfirmRoute,
  AuthenticatedMembersMemberIdEditRoute: AuthenticatedMembersMemberIdEditRoute,
  AuthenticatedMembersCreateConfirmRoute:
    AuthenticatedMembersCreateConfirmRoute,
  AuthenticatedApi_keysApiKeyIdIndexRoute:
    AuthenticatedApi_keysApiKeyIdIndexRoute,
  AuthenticatedMembersMemberIdIndexRoute:
    AuthenticatedMembersMemberIdIndexRoute,
  AuthenticatedMembersCreateIndexRoute: AuthenticatedMembersCreateIndexRoute,
  AuthenticatedUser_rolesPlanIdIndexRoute:
    AuthenticatedUser_rolesPlanIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
